import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  moduleId: module.id,
  selector: 'app-navbar',
  templateUrl: 'app.navbar.component.html',
  styleUrls: ['./app.navbar.component.scss'],

  standalone: false,})
export class AppNavbarComponent implements OnInit {
  @Output() public sidenavToggle = new EventEmitter();
  location: Location;
  private nativeElement: Node;
  private sidebarVisible: boolean;

  @ViewChild('app-navbar-cmp') button: any;

  constructor(location: Location, element: ElementRef) {
    this.location = location;
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
  }

  ngOnInit() {}

  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
  };
}
